import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Plus } from 'lucide-vue-next';
    import { Button } from '@/components/ui/button';
    import {
        Dialog,
        DialogTrigger,
        DialogContent,
        DialogHeader,
        DialogTitle,
        DialogClose,
        DialogFooter,
        DialogBody,
    } from '@/components/ui/dialog';
    import { toast } from 'vue-sonner';
    import { useI18n } from 'vue-i18n';
    import type { Employee, SharedData } from '@/types';
    import { InputRow } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { computed, ref, watch } from 'vue';
    import { useForm, usePage } from '@inertiajs/vue3';
    import { useQueryClient } from '@tanstack/vue-query';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PayrollTableComment',
  props: {
    employee: {},
    comment: {},
    isApproved: { type: Boolean },
    payrollId: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const queryClient = useQueryClient();

    const { t } = useI18n();

    const isOpen = ref(false);

    const buttonText = computed(() => {
        if (!props.isApproved) {
            return props.comment
                ? t('salary.payroll.change_comment')
                : t('salary.payroll.add_comment');
        }

        if (props.comment) {
            return t('salary.payroll.show_comment');
        }
    });

    const form = useForm({
        employeeId: props.employee.id,
        comment: props.comment,
    });

    const updateComment = () => {
        form.post(route('v2.salary.payrolls.add-comment', { payroll: props.payrollId }), {
            preserveScroll: true,
            onSuccess: () => {
                form.resetAndClearErrors();
                toast.success(t('salary.payroll.comment_success'));
                queryClient.invalidateQueries({
                    queryKey: [QueryKey.PAYROLL, selectedCompanyId, props.payrollId],
                });
                isOpen.value = false;
            },
            onError: (error: any) => {
                toast.error(t('forms.system_erro'));
            },
        });
    };

    watch(
        () => props.comment,
        (newVal, oldVal) => {
            if (newVal !== oldVal) {
                form.comment = newVal;
            }
        },
    );

return (_ctx: any,_cache: any) => {
  return (!_ctx.isApproved || (_ctx.isApproved && _ctx.comment))
    ? (_openBlock(), _createBlock(_unref(Dialog), {
        key: 0,
        open: isOpen.value,
        "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                variant: "continue",
                size: "xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(buttonText.value) + " ", 1),
                  _createVNode(_unref(Plus), { class: "size-3" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogContent), { class: "sm:max-w-lg" }, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogHeader), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('salary.payroll.add_comment')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogBody), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(InputRow), {
                    form: _unref(form),
                    name: "comment",
                    label: "salary.payroll.comment"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Textarea), {
                        id: "comment",
                        modelValue: _unref(form).comment,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).comment) = $event)),
                        disabled: _ctx.isApproved,
                        class: "disabled:opacity-100"
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["form"])
                ]),
                _: 1
              }),
              _createVNode(_unref(DialogFooter), { class: "gap-2 border-t sm:justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogClose), { "as-child": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Button), {
                        variant: "outline",
                        size: "sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('forms.cancel')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    disabled: _unref(form).processing || _ctx.isApproved,
                    loading: _unref(form).processing,
                    size: "sm",
                    onClick: updateComment
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('salary.payroll.add_comment')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"]))
    : _createCommentVNode("", true)
}
}

})